import React from 'react';
import { formatDisplayDate } from '../../utils/date-util';

interface RecordTitleProps {
  title: React.ReactNode;
  date?: Date;
}
export const RecordTitle = ({ title, date }: RecordTitleProps) => {
  const tooltipText = typeof title === 'string' ? title : undefined;
  return (
    <div title={tooltipText} className="flex">
      <div className="flex-grow overflow-hidden overflow-ellipsis whitespace-nowrap pr-1">{title}</div>
      {date && <div className="flex-shrink">{formatDisplayDate(date)}</div>}
    </div>
  );
};
